const pluralize = (value, word, plural = word + 's') =>
  [1, -1].includes(Number(value)) ? word : plural

export default pluralize
